<template>
  <div id="landing" class="row">
    <div id="sideBar" class="">
      <!-- <b-dropdown variant="light">
        <template v-slot:button-content>
          <img width="65" height="65" src="img/arc360_icon.png">
        </template>
        <b-dropdown-item disabled>Contact Us</b-dropdown-item>
        <b-dropdown-item @click="logout">Logout</b-dropdown-item>
      </b-dropdown> -->
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <b-nav class="" vertical>
        <div class="" v-for="(item, index) in activeTabFlags">
          <b-nav-item>
            <b-button variant="outline-secondary" :pressed="item.value"  size="sm" class="selectedButton " v-on:click="sideBarClick(index)">
              <b-img id="headerImage" fluid-grow :src="item.imageLink"></b-img>
            </b-button>
          </b-nav-item>
        </div>
      </b-nav>
    </div>
    <div id="embeddedContent" class="col-11" v-for="(item, index) in Object.keys(activeTabFlags)" v-show="activeTabFlags[item].value==true">
      <template>
        <vue-friendly-iframe :src="activeTabFlags[item].link" className="embeddedItem"></vue-friendly-iframe>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MainApp',
  components: {

  },
  props: {
    activeTab: Number
  },
  data() {
    return {

    }
  },
  computed: {
    activeTabFlags: {
      get() {
        return this.$store.state.mainStore.activeTabFlags
      }
    },
  },
  methods: {
    sideBarClick(index) {
      const current = this
      // console.log(index);
      current.$store.commit("mainStore/setActiveTabFlag", index)
      // console.log(current.activeTabFlags);
    },
    logout() {
      console.log("logout clicked");
      const current = this
      current.$store.commit("mainStore/storeAccessToken", "")
      sessionStorage.removeItem("accessToken")
      current.$router.push("/")
      current.$notify({
        group: 'notification_01',
        title: 'Logout Successful',
        text: '',
        type: "success",
        duration: 1500
      });
    }
  },
  mounted() {
    var activeTabIndex = this.$router.currentRoute.params.activeTab?this.$router.currentRoute.params.activeTab:1
    var index = Object.keys(this.activeTabFlags)
    this.sideBarClick(index[activeTabIndex-1])
  }
}
</script>

<style>
#landing {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  height: 93vh!important;
  width: 100vw!important;
  max-height: 100vh!important;
  background: rgba(128, 128, 128, 0.4);
  margin-left: 0;
}
#sideBar {
  background-color: inherit;
  padding:0;
  width: 5vw;
  height: 93vh!important;
}
#embeddedContent {
  padding: 0!important;
  border: none;
  /* background: #000; */
  /* width: 98vw!important; */
}
.embeddedItem {
  height: 93vh!important;
  width: 95vw!important;
}
.frameContainerClass {
  padding:3px!important;
  border-color: #404952;
  border-style: solid;
}
.selectedButton:hover, .selectedButton.active {
  background: rgba(240, 240, 240, 0.5)!important;
  border-color: #e36010!important;
}
</style>
